<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="Perfect-Center _idGenParaOverride-1"><span class="Bold">The FBI estimates that on any given day in America, there are between 50-100 Serial Killers walking among us</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Foreword3.vue?02b6ddc0